export default __webpack_public_path__ + "assets/img/91e26204cf11f3bb4f87359ed92a1fed.svg";